import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Form, FloatingLabel, Button, Modal } from "react-bootstrap";
import { ButtonLoader } from "Components";
import { authService } from "Service/Axios";
import { FORM_BUILDER_FOLDER_ADD_URL } from "Constant/api";
import { Validator } from "Utils/validator";

export const CreateFolder = ({ show, toggle, fetchFolderList }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    folderName: "",
  });
  const [errMsg, setErrMsg] = useState({
    folderName: "",
  });

  const { folderName } = formData;

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (e.target.name === "folderName") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          folderName: t("common.messages.error.common.folderName.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          folderName: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(folderName)) {
        resolve(true);
      } else {
        if (folderName && !Validator.text(folderName)) {
          setErrMsg((prev) => ({
            ...prev,
            folderName: t("common.messages.error.common.folderName.blank"),
          }));
        }
        resolve(false);
      }
    });
  };

  // On Submit
  const onSaveFolder = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      setLoading(true);
      try {
        const payload = {
          folderName,
        };
        const response = await authService(
          FORM_BUILDER_FOLDER_ADD_URL,
          "POST",
          payload
        );
        if (response) {
          if (response.success) {
            setLoading(false);
            fetchFolderList();
            toast.success(
              t("common.messages.notification.success.createFolder")
            );
            toggle();
          } else {
            setLoading(false);
            if (
              response.message ===
              "The folder is already exist. Please try another name."
            ) {
              toast.error(
                t("common.messages.notification.failed.duplicateFolder")
              );
            } else {
              toast.error(response.message);
            }
          }
        }
      } catch (error) {
        setLoading(false);
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("auth.formBuilder.createFolder")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FloatingLabel
          controlId="floatingInput"
          label={t("common.label.folder")}
          className="mb-3"
        >
          <Form.Control
            type="text"
            placeholder={t("common.placeHolder.folderName")}
            name="folderName"
            value={folderName}
            onChange={handleChange}
          />
        </FloatingLabel>
        {errMsg.folderName && <p>errMsg.folderName</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {!loading ? (
          <Button variant="primary" onClick={onSaveFolder}>
            {t("common.button.save")}
          </Button>
        ) : (
          <ButtonLoader />
        )}
      </Modal.Footer>
    </Modal>
  );
};
